module.exports = __webpack_public_path__ + "img/TJK.159a0077.svg";